<template>
    <div class="content" :class="visible ? 'content--visible' : ''">
        <h2>Our public transport perspective</h2>
        <p>
            <strong>Removing driving from the equation illuminates how different parts of the city are best served by public transport modes for the morning commute.</strong>
        </p>
        <p>Trams appear to serve as the most efficient commuting mode in and around the inner city. However, other public transport modes take over as the commute extends outward. Here, the well- established rail network is the mostly the optimal commuting mode. However there are pockets where rail infrastructure is lacking, such as the Airport precinct in the Northwest, where bus is the optimal mode.</p>
        <p>Select a single postcode to follow through the journey.</p>
        <multiselect
            class="postcode__selector"
            :value="selectedPostcode"
            :options="data"
            track-by="postcode"
            label="label"
            @input="update_selected_postcode"
        ></multiselect>
    </div>
</template>

<script>
import tooltip_mixin from "@/assets/tooltip_mixin";

export default {
    props: {
        visible: {
            default: () => false
        }
    },
    mixins: [tooltip_mixin]
};
</script>

<style scoped>
.postcode__selector {
    width: 80%;
}
</style>